import { ref as dbRef, onValue } from 'firebase/database'
import { realtimeDb } from '@/firebase/config'
import type { AgentState } from '@/types/Agent'

export class AgentStateService {
  private agentsRef = dbRef(realtimeDb, 'agents')

  // Subscribe to agent presence changes
  subscribeToAgentPresence(callback: (agents: AgentState[]) => void): () => void {
    return onValue(this.agentsRef, (snapshot) => {
      const agents: AgentState[] = []
      snapshot.forEach((childSnapshot) => {
        const data = childSnapshot.val()
        if (data && data.state) {
          agents.push({
            id: childSnapshot.key!,
            name: data.agent?.name || childSnapshot.key!,
            location: data.agent?.location || null,
            state: data.state,
            lastSeen: data.lastSeen,
            startedAt: data.startedAt,
            version: data.version,
            ip: data.ip,
            caps: data.caps || [],
            roles: data.agent?.roles || [],
            capabilities: data.agent?.capabilities || data.caps || [],
            devices: data.devices || [],
          })
        }
      })
      callback(agents)
    })
  }
}

// Factory function for creating service instances
export function useAgentStateService(): AgentStateService {
  return new AgentStateService()
}
